"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

function stateHasErrorProperty(state) {
  return 'error' in state;
}
/**
 * Typescript decorator function
 *
 * @example
 * class MyClass extends SafeAsyncComponent {
 *      ...
 *
 *      @bindCallback
 *      myCallback() {
 *          ...
 *      }
 * }
 */


exports.bindCallback = function (target, propertyKey) {
  if (typeof target.bindNames === 'undefined') {
    target.bindNames = [];
  }

  target.bindNames.push(propertyKey);
};

var SafeAsyncComponent =
/** @class */
function (_super) {
  __extends(SafeAsyncComponent, _super);

  function SafeAsyncComponent(props) {
    var _this = _super.call(this, props) || this;
    /**
     * Run bindCallback on all names defined by @bindCallback (see bindCallback descriptor)
     */


    var names = Object.getPrototypeOf(_this).bindNames;

    if (names) {
      names.forEach(function (name) {
        var fn = _this[name];

        if (typeof fn === 'function') {
          _this[name] = _this.bindCallback(fn);
        }
      });
    }

    return _this;
  }

  SafeAsyncComponent.prototype.componentDidMount = function () {
    var _this = this; // Using anonymous async function to avoid type error with potential
    // super-class that override componentDidMount.
    // See: https://github.com/Microsoft/TypeScript/issues/7284


    (function () {
      return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);

              return [4
              /*yield*/
              , this.safeComponentDidMount()];

            case 1:
              return [2
              /*return*/
              , _a.sent()];

            case 2:
              error_1 = _a.sent();
              this.safeThrowError(error_1);
              return [3
              /*break*/
              , 3];

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    })();
  };

  SafeAsyncComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _this = this; // See comment in componentDidMount.


    (function () {
      return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);

              return [4
              /*yield*/
              , this.safeComponentDidUpdate(prevProps, prevState)];

            case 1:
              return [2
              /*return*/
              , _a.sent()];

            case 2:
              error_2 = _a.sent();
              this.safeThrowError(error_2);
              return [3
              /*break*/
              , 3];

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    })();
  };

  SafeAsyncComponent.prototype.componentWillUnmount = function () {
    try {
      return this.safeComponentWillUnmount();
    } catch (error) {
      this.safeThrowError(error);
    }
  };

  SafeAsyncComponent.prototype.safeComponentWillUnmount = function () {// No default behavior
  };

  SafeAsyncComponent.prototype.safeComponentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        ];
      });
    });
  };

  SafeAsyncComponent.prototype.safeComponentDidUpdate = function (prevProps, prevState) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        ];
      });
    });
  };
  /**
   * Throw an error that can be caught by the React runtime.
   */


  SafeAsyncComponent.prototype.safeThrowError = function (error) {
    if (this.context.throwError) {
      this.context.throwError(error);
    } else {
      this.setState(function () {
        throw error;
      });
    }
  };
  /**
   * Bind provided callback to this, and wrap with try-catch that will
   * rethrow errors via safeThrowError.
   */


  SafeAsyncComponent.prototype.bindCallback = function (callback) {
    var _this = this;

    return function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      try {
        return callback.apply(_this, args);
      } catch (error) {
        _this.safeThrowError(error);
      }
    };
  };

  SafeAsyncComponent.contextTypes = {
    throwError: PropTypes.func
  };
  return SafeAsyncComponent;
}(React.Component);

exports["default"] = SafeAsyncComponent;